import React, { useEffect, useState, useCallback } from 'react';
import qs from 'qs';
import { toast } from 'react-toastify';

import { functions } from '../../firebase';

const confirmInvitation = functions.httpsCallable('confirmInvitation');

export default function Confirmation (props) {
  const { history } = props;
  const [loading, setLoading] = useState(true);

  const confirm = useCallback(async () => {
    try {
      const { token } = qs.parse(window.location.search.slice(1), { arrayLimit: Infinity });

      if (!token) {
        toast.error('招待URLが無効です');
        history.push('/');
        return;
      }

      const { data } = await confirmInvitation({ token });
      const { companyId } = data || {};

      toast.success('参加しました');
      history.push(`/companies/${companyId}`);
    } catch (error) {
      const errorCode = error?.code;
      const errorMessage = (_ => {
        if (errorCode === 'functions/permission-denied') return 'この招待はあなた宛ではありません';
        if (errorCode === 'functions/not-found') return '招待が見つかりません。URLが無効か、有効期限が切れています';
        if (errorCode === 'functions/already-exists') return 'すでに参加済みです';
        return '招待の確認に失敗しました';
      })();

      toast.error(errorMessage);
      history.push('/');
    } finally {
      setLoading(false);
    }
  }, [history]);

  useEffect(() => {
    confirm();
  }, [confirm]);

  return (
    <div className="confirmation d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
      {loading && (
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">読み込み中...</span>
          </div>
          <p className="mt-3">招待を確認しています...</p>
        </div>
      )}
    </div>
  );
}
